var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99196 9.17746H4.23189V14.3967C4.23189 15.6145 4.89155 15.861 5.69618 14.9476L11.1836 8.71352C11.8578 7.95238 11.5751 7.32172 10.553 7.32172H8.31306V2.10247C8.31306 0.88465 7.6534 0.638186 6.84877 1.55155L1.3613 7.78566C0.6944 8.55405 0.97711 9.17746 1.99196 9.17746Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicCharger);
export default __webpack_public_path__ + "static/media/PublicCharger.0723cadf0dc643a3ea4e75acba10e313.svg";
export { ForwardRef as ReactComponent };